import {
  TextField,
  Grid,
  Tooltip,
} from '@mui/material';
import TemperatureTrackerTable from "./TemperatureTrackerTable"
import ComingSoon from "../../common/ComingSoon"

const TemperatureTrackers = () => {



  return (
    <div className="vlp-component-container">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span className="title">Temperature Tracker</span>
      </div>
      <hr />

      <TemperatureTrackerTable />



    </div>
  );
};

export default TemperatureTrackers;